import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_SIMULATE_EHR_LIST_REQUEST = 'GET_SIMULATE_EHR_LIST_REQUEST';
export const GET_SIMULATE_EHR_LIST_SUCCESS = 'GET_SIMULATE_EHR_LIST_SUCCESS';
export const GET_SIMULATE_EHR_LIST_ERROR = 'GET_SIMULATE_EHR_LIST_ERROR';
export const GET_SIMULATE_EHR_LIST_RESET = 'GET_SIMULATE_EHR_LIST_RESET';

export const getSimulateEhrListApi = (data) => {
	return async (dispatch) => {
		dispatch({ type: GET_SIMULATE_EHR_LIST_REQUEST });
		try {
			const response = await axios.get(
				`${config.api.base_url}/simulate-ehr/list`,
				{
					params: {
						search: data.search,
						page: data.page,
						limit: data.limit,
						sort: data.sort,
						sortDirection: data.sortDirection,
					},
					headers: {
						'Content-type': 'application/json; charset=UTF-8',
						Authorization: 'Bearer ' + getUserToken(),
					},
				},
			);
			dispatch({
				type: GET_SIMULATE_EHR_LIST_SUCCESS,
				payload: response.data,
			});
		} catch (error) {
			dispatch({
				type: GET_SIMULATE_EHR_LIST_ERROR,
				payload: error.response?.data?.message || 'Something went wrong',
			});
		}
	};
};

export const getSimulateEhrListReset = () => {
	return {
		type: GET_SIMULATE_EHR_LIST_RESET,
	};
}; 